import { render, staticRenderFns } from "./Floor1.vue?vue&type=template&id=4f8252e6"
import script from "./Floor1.vue?vue&type=script&lang=js"
export * from "./Floor1.vue?vue&type=script&lang=js"
import style0 from "./Floor1.vue?vue&type=style&index=0&id=4f8252e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports